const menuItems = [
    {
      title: "Home",
      url: "/#home",
      cName: "nav-links"
    },
    {
      title: "About",
      url: "/#about",
      cName: "nav-links"
    },
    {
        title: "Skill",
        url: "/#skill",
        cName: "nav-links"
      },
      {
        title: "Service",
        url: "/#service",
        cName: "nav-links"
      },
    {
      title: "Portfolio",
      url: "/#portfolio",
      cName: "nav-links"
    },
    {
      title: "Client",
      url: "/#client",
      cName: "nav-links"
    },
    {
        title: "Pricing",
        url: "/#pricing",
        cName: "nav-links"
      },
      {
        title: "Blog",
        url: "/#blog",
        cName: "nav-links"
      },
    
    {
      title: "Contact",
      url: "/#contacts",
      cName: "nav-links"
    }
  ];
  
  export default menuItems;
  